import styles from './Price.module.css';
export interface PriceProps {
	price: number;
	showFree?: boolean;
	testId?: string;
	showDecimal?: boolean;
}

export function Price({ price, showFree, testId, showDecimal }: PriceProps) {
	const [integerPortion, decimalPortion] = price.toFixed(2).toString().split('.');

	return (
		<div className={styles.Price} data-testid={testId}>
			{price === 0 && showFree ? 'FREE' : `$${integerPortion}${showDecimal ? '.' : ''}`}
			{showDecimal && (
				<span className={styles.decimalPortion}>{!(price === 0 && showFree) && decimalPortion}</span>
			)}
		</div>
	);
}
